import { AlertTriangle } from "lucide-react";
import { draftTokens } from "@/lib/context";

/** How much of the model's context the conversation (plus the unsent draft) takes. */
export default function ContextGauge({ used, length, draft }: { used: number; length: number; draft: string }) {
  const total = used + draftTokens(draft);
  const share = total / length;
  const pct = Math.min(Math.round(share * 100), 999);
  const over = share >= 1;
  const near = share >= 0.85;
  const tone = over ? "text-red-600 dark:text-red-400" : near ? "text-amber-600 dark:text-amber-400" : "text-zinc-500";
  const bar = over ? "bg-red-500" : near ? "bg-amber-500" : "bg-indigo-500";
  const text = `${total.toLocaleString()} of ${length.toLocaleString()} tokens${used ? "" : " (draft only; the conversation is counted after the first answer)"}`;
  return (
    <span className={`flex items-center gap-1 px-1 text-xs tabular-nums ${tone}`} title={`Context: ${text}`} role="status">
      {near && <AlertTriangle size={12} aria-hidden />}
      <span className="h-1.5 w-10 overflow-hidden rounded-full bg-zinc-200 dark:bg-zinc-700" aria-hidden>
        <span className={`block h-full ${bar}`} style={{ width: `${Math.min(share * 100, 100)}%` }} />
      </span>
      <span>{pct}%</span>
      {over && <span className="hidden sm:inline">Too long for this model; start a new chat or remove attachments.</span>}
      {!over && near && <span className="hidden sm:inline">Context nearly full</span>}
    </span>
  );
}
